module.exports = __webpack_public_path__ + "img/dori_Biofer.6e897d8f.png";